import type { JSX } from 'react';
import { TextField } from '../../../../_components/TextField.js';
import type { Palette } from '../../../../_theme/palette.js';

export type DateInputType = 'date' | 'datetime-local' | 'time' | 'month';

interface DateFieldProps {
  palette: Palette;
  type: DateInputType;
  value: unknown;
  onChange: (value: string) => void;
  ariaLabel?: string;
  placeholder?: string;
}

// Native date / time / datetime / month input wrapped with a themed calendar
// or clock icon at the trailing edge — mirrors the main app's TimeDatePreviews
// pattern. Uses the system picker on every platform: tap on iOS opens the
// wheel picker, on Android opens the modal date picker, on desktop the
// browser calendar dropdown.
export function DateField({ palette, type, value, onChange, ariaLabel, placeholder }: DateFieldProps): JSX.Element {
  const safeValue = typeof value === 'string' ? value : '';
  const Icon = type === 'time' ? ClockIcon : CalendarIcon;
  return (
    <TextField
      palette={palette}
      type={type}
      value={safeValue}
      onChange={onChange}
      ariaLabel={ariaLabel}
      placeholder={placeholder}
      trailingIcon={<Icon />}
    />
  );
}

function CalendarIcon(): JSX.Element {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function ClockIcon(): JSX.Element {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}
